import { useState, useRef, useEffect } from "react";

const ColorDropdown = ({ colorList, selectedColorId, onSelect }) => {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleSelect = (color) => {
        onSelect(color);
        setOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const selected = colorList.find(c => c?.colorCode === selectedColorId);

    return (
        <div className="relative w-full" ref={dropdownRef}>
            <button
                className="w-full !px-3 !py-1.5 border rounded-md flex gap-1 items-center justify-between bg-white shadow-sm text-sm"
                onClick={() => setOpen(!open)}
            >
                {selected ? (
                    <div className="flex items-center gap-2">
                        <span className="inline-block w-4 h-4 rounded" style={{ backgroundColor: selected.colorCode }}></span>
                        {selected.name}
                    </div>
                ) : (
                    <span className="text-gray-500">Select Color</span>
                )}
                <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
            </button>

            {open && (
                <div className="absolute z-10 mt-1 w-max max-w-[200px] bg-white border rounded-md shadow-lg max-h-60 overflow-y-auto overflow-x-hidden ">
                    {colorList?.map((color) => (
                        <div
                            key={color?._id}
                            className="px-3 py-2 hover:bg-gray-100 cursor-pointer flex items-center gap-2 text-sm"
                            onClick={() => handleSelect(color)}
                        >
                            <div className="!w-4 !h-4 rounded-sm " style={{ backgroundColor: color?.colorCode }}></div>
                            <p className="text-xs truncate">{color?.name}</p>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ColorDropdown